import { DatePickerBase, DatePickerBaseProps } from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";

export const DatePicker = (
  props: DatePickerBaseProps & {
    modelProperty?: ModelPropertyBase | undefined;
  }
) => {
  const { modelProperty, ...rest } = props;

  return <DatePickerBase label={props.modelProperty?.displayName} required={props.modelProperty?.required} {...rest} />;
};
